import { ValidationErrors } from "@angular/forms";

export interface IValidationRules {
  required?: boolean;
  minLength?: number;
  maxLength?: boolean;
  pattern?: RegExp;
  requiredTrue?: boolean;
  maxDate?: Date;
  minDate?: Date;
  satisfies?: () => ValidationErrors | null;
}

export const isValidationRule = (rule: any): rule is IValidationRules => {
  const validationRule = rule as IValidationRules;
  return (
    validationRule?.required != undefined ||
    validationRule?.maxLength != undefined ||
    validationRule?.minLength != undefined ||
    validationRule?.pattern != undefined ||
    validationRule?.requiredTrue != undefined ||
    validationRule?.maxDate != undefined ||
    validationRule?.minDate != undefined ||
    validationRule?.satisfies != undefined
  );
};

export type IFormValidationRules<T> = {
  [key in keyof Partial<T>]: T[key] extends (infer U)[] | undefined
    ?
        | IValidationRules
        | IFormValidationRules<Partial<U>>
        | IFormValidationRules<Partial<U>[]>
        | undefined
    : undefined | IValidationRules | IFormValidationRules<Partial<T[key]>>;
};
